export function uploadFileToSignedUrl(
  signedUrl: string,
  file: File,
  onProgress?: (percent: number) => void,
  options?: { signal?: AbortSignal }
): Promise<void> {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest();
    xhr.open("PUT", signedUrl);
    xhr.setRequestHeader("Content-Type", file.type);

    const signal = options?.signal;
    const handleAbortSignal = () => xhr.abort();

    const cleanup = () => {
      signal?.removeEventListener("abort", handleAbortSignal);
    };

    xhr.upload.onprogress = (event) => {
      if (!onProgress || !event.lengthComputable) return;
      onProgress(Math.round((event.loaded / event.total) * 100));
    };

    xhr.onload = () => {
      cleanup();
      if (xhr.status >= 200 && xhr.status < 300) {
        resolve();
      } else {
        reject(new Error(`Upload failed with status ${xhr.status}`));
      }
    };

    xhr.onerror = () => {
      cleanup();
      reject(new Error("Upload failed"));
    };

    xhr.onabort = () => {
      cleanup();
      const error = new Error("Upload aborted");
      error.name = "AbortError";
      reject(error);
    };

    if (signal) {
      if (signal.aborted) {
        cleanup();
        const error = new Error("Upload aborted");
        error.name = "AbortError";
        reject(error);
        return;
      }
      signal.addEventListener("abort", handleAbortSignal);
    }

    xhr.send(file);
  });
}
